import type { IDirective, IWindowService } from "angular";
import { element, module } from "angular";
import { Subject } from "rxjs";

const MIN_HEIGHT_FOR_MODAL = 400;

export default class StretchParentDirective implements IDirective {
    constructor(private readonly $window: IWindowService) {}

    public link($scope: any, $element: JQuery) {
        const resizeOverlaySubject = new Subject();
        const windowElement = element(this.$window);

        const insideModal = !!$element.parents(".modal-content").length;

        const onResize = () => resizeOverlaySubject.next();

        $scope.$watch(() => resizeOverlaySubject.next());
        windowElement.on("resize", onResize);

        resizeOverlaySubject.subscribe(() => {
            const overlayParent = $element.parent().parent();
            overlayParent.css({
                display: "block",
                position: "relative",
            });

            const heightToFillScreen = insideModal
                ? MIN_HEIGHT_FOR_MODAL
                : windowElement.height() - $element.offset().top;

            const actualHeight = overlayParent.height();
            const overlayParentMinHeight = overlayParent.css("min-height");

            const currentMinHeight = overlayParentMinHeight
                ? Number(overlayParentMinHeight.replace("px", ""))
                : MIN_HEIGHT_FOR_MODAL;

            if (heightToFillScreen > actualHeight || currentMinHeight > heightToFillScreen) {
                overlayParent.css({ "min-height": heightToFillScreen });
            }
        });

        $scope.$on("$destroy", () => {
            windowElement.off("resize", onResize);
        });
    }
}

module("mmGui").directive("irStretchParent", [
    "$window",
    ($window: IWindowService) => new StretchParentDirective($window),
]);
